import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import moment from "moment";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import { EditButton, EditMessageImg, EditMessageText } from "./styles";
import Axios from "../../../../config/axios";
import Popup from "../../../popup";
import MessageCanvas from "../messageCanvas";
// Assets
import EditImg from "../../../../assets/icons/btn_edit_user_blue.svg";

const UpdateMessage = ({
  patientProtocols,
  COACH_MESSAGES_ID,
  COACH_MESSAGES_PER_PATIENT_ID,
  COACH_MESSAGES_PER_PROTOCOL_ID,
  currentMessageType,
  currentProtocolId,
  currentMessageText,
  currentShowOnlyOnce,
  currentLaunchDays,
  currentLaunchTime,
  currentDeleteTime,
  setIsLoadingMessages,
  rechargeMessages,
  setRechargeMessages,
}) => {
  const [isShowingUpdateMessageForm, setIsShowingUpdateMessageForm] = useState(false);
  // Message fields
  const [protocolId, setProtocolId] = useState(0);
  const [messageText, setMessageText] = useState("");
  const [showOnlyOnce, setShowOnlyOnce] = useState(false);
  const [launchTime, setLaunchTime] = useState("");
  const [launchDays, setLaunchDays] = useState([]);
  const [deleteTime, setDeleteTime] = useState("");

  const { patientId } = useParams();
  const [t] = useTranslation("global");

  useEffect(() => {
    setProtocolId(currentProtocolId);
    setMessageText(currentMessageText);
    setShowOnlyOnce(currentShowOnlyOnce);
    setLaunchDays(currentLaunchDays);
    setLaunchTime(currentLaunchTime);
    setDeleteTime(currentDeleteTime);
  }, [
    currentDeleteTime,
    currentLaunchDays,
    currentLaunchTime,
    currentMessageText,
    currentMessageType,
    currentProtocolId,
    currentShowOnlyOnce,
    isShowingUpdateMessageForm,
  ]);

  const getToday = () => {
    const days = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
    return [days[new Date(deleteTime).getDay()]];
  };

  const handleUpdateMessage = (e) => {
    e.preventDefault();
    if (currentMessageType === "ON_PROTOCOL" && !protocolId) return toast.error(t("coachMessages_alerts_selectProtocol"));
    if (!messageText) return toast.error(t("coachMessages_alerts_addMessage"));
    if (!showOnlyOnce && !launchDays.length) return toast.error(t("coachMessages_alerts_selectDays"));
    if (!launchTime && currentMessageType === "NOTIFICATION") return toast.error(t("coachMessages_alerts_selectTime"));
    if (showOnlyOnce && !deleteTime) return toast.error(t("coachMessages_alerts_selectDate"));
    if (deleteTime && !moment(new Date(deleteTime), "DD/MM/YYYY", true).isValid())
      return toast.error(t("coachMessages_alerts_selectValidDate"));
    if (deleteTime && deleteTime < new Date()) return toast.error(t("coachMessages_alerts_selectHigherDate"));

    const message = {
      COACH_MESSAGES_ID,
      MESSAGE: messageText,
      SENDER: "CLINICIAN",
      TYPE: currentMessageType,
      COACH_MESSAGES_PER_PATIENT_ID,
      SHOW_ONLY_ONCE: showOnlyOnce,
      DELETE_TIME: deleteTime ? deleteTime : null,
      LAUNCH_TIME: launchTime,
      LAUNCH_DAYS: !showOnlyOnce ? launchDays : getToday(),
    };
    if (currentMessageType === "ON_PROTOCOL") {
      message.COACH_MESSAGES_PER_PROTOCOL_ID = COACH_MESSAGES_PER_PROTOCOL_ID;
      message.PROTOCOL_ID = protocolId;
    }

    Axios("put", `${WEB_SERVICE_MIMS}/coach-messages/update-message/${patientId}`, message)
      .then(({ data }) => {
        if (data.updatedMessage) {
          toast.success(t("coachMessages_alerts_updatedMessageSuccessfully"));
          setIsLoadingMessages(true);
          setRechargeMessages(!rechargeMessages);
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("Endpoint to update message", error);
      });
  };

  return (
    <>
      <EditButton onClick={() => setIsShowingUpdateMessageForm(true)}>
        <EditMessageImg src={EditImg} alt="ico-edit" />
        <EditMessageText>{t("coachMessages_editMessage")}</EditMessageText>
      </EditButton>
      <Popup isShowed={isShowingUpdateMessageForm} setIsShowed={setIsShowingUpdateMessageForm}>
        <MessageCanvas
          title={t("coachMessages_editMessage")}
          isOnlyDisplayed={true}
          COACH_MESSAGES_ID={COACH_MESSAGES_ID}
          COACH_MESSAGES_PER_PATIENT_ID={COACH_MESSAGES_PER_PATIENT_ID}
          COACH_MESSAGES_PER_PROTOCOL_ID={COACH_MESSAGES_PER_PROTOCOL_ID}
          patientProtocols={patientProtocols}
          messageType={currentMessageType}
          protocolId={protocolId}
          setProtocolId={setProtocolId}
          messageText={messageText}
          setMessageText={setMessageText}
          showOnlyOnce={showOnlyOnce}
          setShowOnlyOnce={setShowOnlyOnce}
          launchDays={launchDays}
          setLaunchDays={setLaunchDays}
          launchTime={launchTime}
          setLaunchTime={setLaunchTime}
          deleteTime={deleteTime}
          setDeleteTime={setDeleteTime}
          setIsShowingMessageForm={setIsShowingUpdateMessageForm}
          saveMessage={handleUpdateMessage}
          isUpdateCanvas={true}
          isShowingUpdateMessageForm={isShowingUpdateMessageForm}
          setIsLoadingMessages={setIsLoadingMessages}
          rechargeMessages={rechargeMessages}
          setRechargeMessages={setRechargeMessages}
        />
      </Popup>
    </>
  );
};

export default UpdateMessage;
